import 'swiper/swiper-bundle.css'
import Swiper from 'swiper/bundle'

const onClick = (button, swiper, buttons) => {
  const isActive = button.classList.contains('is-active')
  const btnGroup = button.getAttribute('data-group')

  if (!isActive) {
    buttons.forEach(item => item.classList.remove('is-active'))
    button.classList.add('is-active')

    swiper.slides.forEach(el => {
      if (btnGroup === 'all') {
        el.style.display = ''
      } else {
        el.style.display = 'none'

        if (el.dataset.group === btnGroup) {
          el.style.display = ''
        }
      }
    })

    swiper.update()
    swiper.slideTo(0)

    if (btnGroup !== 'all') {
      if (
        swiper.slides.filter(item => item.dataset.group === btnGroup).length <
        swiper.params.slidesPerView
      ) {
        swiper.navigation.nextEl.classList.add('swiper-button-disabled')
      }
    } else {
      // eslint-disable-next-line
      if (swiper.slides.length > swiper.params.slidesPerView) {
        swiper.navigation.nextEl.classList.remove('swiper-button-disabled')
      }
    }
  }
}

export default function(el) {
  const { carouselSlider } = el.dataset
  // const links = el.querySelectorAll('a')
  const pagination = document.querySelector(
    `[data-carousel-counter=${carouselSlider}]`
  )
  let current
  let all
  if (pagination) {
    current = pagination.querySelector('[data-counter-current]')
    all = pagination.querySelector('[data-counter-all]')
  }
  const prev = document.querySelector(`[data-carousel-prev=${carouselSlider}]`)
  const next = document.querySelector(`[data-carousel-next=${carouselSlider}]`)
  let swiper
  let filterButtons

  switch (carouselSlider) {
    case 'news':
      // eslint-disable-next-line no-case-declarations
      filterButtons = document.querySelectorAll(
        `[data-filter-button=${carouselSlider}]`
      )

      swiper = new Swiper(el, {
        // Responsive breakpoints
        breakpoints: {
          1024: {
            slidesPerView: 2.6,
          },
          480: {
            slidesPerView: 1.9,
          },
          320: {
            slidesPerView: 1.2,
          },
        },
        freeMode: true,
        keyboard: true,
        slidesPerView: 1,
        spaceBetween: 32,
        preloadImages: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true,
        },
        speed: 1000,
        watchSlidesVisibility: true,
        slidesOffsetBefore: 32,
      })

      if (filterButtons.length) {
        filterButtons.forEach(button => {
          button.addEventListener(
            'click',
            () => onClick(button, swiper, filterButtons),
            false
          )
        })
      }
      break
    case 'people':
      swiper = new Swiper(el, {
        // Responsive breakpoints
        breakpoints: {
          820: {
            slidesPerView: 3.3,
          },
          640: {
            slidesPerView: 2.6,
          },
          480: {
            slidesPerView: 1.9,
          },
          320: {
            slidesPerView: 1.2,
          },
        },
        freeMode: true,
        keyboard: true,
        slidesPerView: 1,
        spaceBetween: 32,
        preloadImages: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true,
        },
        speed: 1000,
        watchSlidesVisibility: true,
        slidesOffsetBefore: 32,
      })

      break
    case 'webinars':
      // eslint-disable-next-line no-case-declarations
      filterButtons = document.querySelectorAll(
        `[data-filter-button=${carouselSlider}]`
      )
      swiper = new Swiper(el, {
        // Responsive breakpoints
        breakpoints: {
          820: {
            slidesPerView: 4,
          },
          640: {
            slidesPerView: 3,
          },
          480: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1.2,
          },
        },
        keyboard: true,
        slidesPerView: 1,
        spaceBetween: 16,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        speed: 1000,
        watchSlidesVisibility: true,
        // slidesOffsetBefore: 32,
      })

      if (filterButtons.length) {
        filterButtons.forEach(button => {
          button.addEventListener(
            'click',
            () => onClick(button, swiper, filterButtons),
            false
          )
        })
      }

      break
    case 'gallery':
      swiper = new Swiper(el, {
        on: {
          init() {
            current.innerHTML = this.activeIndex + 1
            all.innerHTML = this.slides.length
          },
          slideChange() {
            current.innerHTML = this.activeIndex + 1
          },
        },
        // Responsive breakpoints
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1.2,
          },
        },
        keyboard: true,
        spaceBetween: 32,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        speed: 1000,
        watchSlidesVisibility: true,
      })

      break

    case 'awards':
      swiper = new Swiper(el, {
        // Responsive breakpoints
        breakpoints: {
          640: {
            slidesPerView: 2.5,
          },
          480: {
            slidesPerView: 1.9,
          },
          320: {
            slidesPerView: 1.2,
          },
        },
        freeMode: true,
        keyboard: true,
        slidesPerView: 1,
        spaceBetween: 32,
        preloadImages: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true,
        },
        speed: 1000,
        watchSlidesVisibility: true,
        slidesOffsetBefore: 32,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
      })

      break

    case 'gallery-inner':
      // eslint-disable-next-line no-case-declarations
      const galleryThumbs = new Swiper(
        `[data-carousel-thumbs=${carouselSlider}]`,
        {
          slidesPerView: 'auto',
          spaceBetween: 32,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
            loadOnTransitionStart: true,
          },
          speed: 400,
          loop: true,
          freeMode: true,
          centeredSlides: true,
        }
      )

      swiper = new Swiper(el, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        spaceBetween: 10,
        preloadImages: false,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true,
        },
        speed: 400,
        thumbs: {
          swiper: galleryThumbs,
        },
        loop: true,
      })

      break

    default:
      swiper = new Swiper(el)
  }

  return swiper
}
